import React from 'react'
import Banner from '../Banner'
import {
    Box,
    Container,
    Grid,
    Typography,
    Button,
    Link as MuiLink,
} from "@mui/material"

const Home = () => {
    return (
        <>
            <Banner id="e1d0c673-c649-4de3-947c-c8236f9f9860" />
            <Box component="section">
                {/* Hero headline */}
                <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
                    <Typography
                        component="h2"
                        variant="h4"
                        align="center"
                        sx={{
                            color: "text.primary",
                            fontWeight: 300,
                            mb: 3,
                            lineHeight: 1.15,
                        }}
                    >
                        Reimagine{" "}
                        <Box component="span" sx={{ fontWeight: 700 }}>
                            Plastic.
                        </Box>{" "}
                        Redefine India's{" "}
                        <Box component="span" sx={{ fontWeight: 700 }}>
                            Future.
                        </Box>
                    </Typography>

                    {/* Subtitle / paragraphs */}
                    <Grid container justifyContent="center">
                        <Grid item xs={11} lg={10}>
                            <Box textAlign="center">
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        color: "#0eb482", // green text
                                        fontStyle: "italic",
                                        fontSize: { xs: "1rem", md: "1.125rem" },
                                        fontWeight: 300,
                                        mb: 3,
                                    }}
                                >
                                    India's open innovation sprint for breakthrough ideas in{" "}
                                    <Box component="span" sx={{ fontWeight: 700 }}>
                                        plastics
                                    </Box>
                                    .
                                </Typography>

                                <Typography variant="body1" sx={{ mb: 2 }}>
                                    A{" "}
                                    <Box component="span" sx={{ fontWeight: 700 }}>
                                        flagship initiative of PLASTINDIA 2026
                                    </Box>
                                    , India's largest and the world's third-largest plastics
                                    exhibition. Held in collaboration with{" "}
                                    <Box component="span" sx={{ fontWeight: 700 }}>
                                        IIM Calcutta Innovation Park (IIMCIP)
                                    </Box>
                                    , Bharat Next Challenge celebrates{" "}
                                    <Box component="span" sx={{ fontWeight: 700 }}>
                                        Talent — one of Prime Minister Narendra Modi's 5Ts of Brand
                                        India.
                                    </Box>
                                </Typography>

                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    Have an idea{" "}
                                    <Box component="span" sx={{ fontWeight: 700 }}>
                                        born in India?
                                    </Box>
                                </Typography>

                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    Discover, Create, and Shine at PLASTINDIA Foundation Startup
                                    Search 2026!
                                </Typography>

                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    <Box component="span" sx={{ fontWeight: 700 }}>
                                        Bharat Next Challenge
                                    </Box>{" "}
                                    is India's national innovation movement to re-imagine the most
                                    versatile material on Earth{" "}
                                    <Box component="span" sx={{ fontWeight: 700 }}>
                                        — plastic —
                                    </Box>{" "}
                                    and to make India a global leader in sustainable solutions
                                    built on it.
                                </Typography>

                                <Typography variant="body1" sx={{ mb: 2 }}>
                                    Together, we champion innovations that connect creativity,
                                    sustainability, and scale.
                                </Typography>

                                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                    Every idea that transforms plastic belongs here.
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>

                {/* CTA Strip */}
                <Box sx={{ backgroundColor: "#0eb482" }}>
                    <Container maxWidth="lg">
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                py: 4,
                                textAlign: "center",
                                gap: 1,
                            }}
                        >
                            {/* Register Button */}
                            <MuiLink
                                href="/register/e1d0c673-c649-4de3-947c-c8236f9f9860"
                                underline="none"
                                // target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Button
                                    variant="text"
                                    sx={{
                                        color: "#fff",
                                        fontSize: { xs: "1.5rem", md: "2rem" },
                                        fontWeight: 300,
                                        textTransform: "none",
                                    }}
                                >
                                    Register now
                                </Button>
                            </MuiLink>

                            {/* Terms and Conditions + Privacy Policy */}
                            <Typography
                                variant="body2"
                                sx={{ color: "#ffffff", mt: 1, opacity: 0.9 }}
                            >
                                <MuiLink
                                    href={`/terms-and-conditions/e1d0c673-c649-4de3-947c-c8236f9f9860`}
                                    target="_blank"
                                    underline="always"
                                    sx={{ color: "#ffffff" }}
                                >
                                    Terms and Conditions
                                </MuiLink>{" "}
                                and{" "}
                                <MuiLink
                                    href={`/privacy-policy/e1d0c673-c649-4de3-947c-c8236f9f9860`}
                                    target="_blank"
                                    underline="always"
                                    sx={{ color: "#ffffff" }}
                                >
                                    Privacy Policy
                                </MuiLink>
                            </Typography>
                        </Box>
                    </Container>
                </Box>


                {/* Secondary pale section */}
                <Box component="section" sx={{ backgroundColor: "#f8f9fa", py: 5 }}>
                    <Container maxWidth="lg">
                        <Box textAlign="center" mb={4}>
                            {/* Add any heading or content you want here */}
                            <Typography variant="h6" sx={{ fontWeight: 500 }}>
                                {/* placeholder for the next centered heading */}
                            </Typography>
                        </Box>
                    </Container>
                </Box>
            </Box>
            
        </>
    )
}

export default Home